import { Component, ComponentRef, effect, inject, Injector, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { DrawerRef } from './drawer-ref';
import { DRAWER_DATA } from './drawer.tokens';
import { DrawerService } from '../../services/drawer-service';
import { User } from '../../../pages/access/user/user';

@Component({
  selector: 'app-drawer',
  imports: [DrawerModule, AvatarModule, ButtonModule],
  templateUrl: './drawer.html',
  styleUrl: './drawer.scss',
})
export class Drawer implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;

  private drawerService = inject(DrawerService)

  @Input() position: string = 'right';

  private componentRef?: ComponentRef<any>;
  private dialogRef?: DrawerRef;
  visible = false;
  width = '30rem';
  header: string | undefined = 'Header'
  customClass: string | undefined = undefined
  showHeader: boolean = true;
  drawerPT: any;
  closable: boolean = false;

  ngOnInit(): void {
    this.drawerService.register(this);
  }

  open(
    component: Type<any>,
    data?: any,
    config?: { width?: string; position?: 'left' | 'right', showHeader?: boolean, header?: string; customClass?: string; closable?: boolean }
  ) {
    this.container.clear();

    this.dialogRef = new DrawerRef();

    const injector = Injector.create({
      providers: [
        { provide: DrawerRef, useValue: this.dialogRef },
        { provide: DRAWER_DATA, useValue: data },
      ],
    });

    this.componentRef = this.container.createComponent(component, {
      injector,
    });

    this.width = config?.width || '32rem';
    this.position = config?.position || 'right';
    this.header = config?.header;
    this.customClass = config?.customClass;
    this.showHeader = config?.showHeader ?? true;
    this.closable = config?.closable ?? false;
    this.setHeaderVisiblity();
    this.visible = true;
    console.log('Drawer opened with component:', component.name, 'Data:', data, 'Config:', config);
    // Close from inside component
    this.dialogRef.afterClosed().subscribe(() => {
      this.onClose();
    });

    return this.dialogRef;
  }

  onClose() {
    this.visible = false;

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = undefined;
    }

    this.container.clear();
    this.drawerService.drawerClosed.set(true);
  }

  setHeaderVisiblity() {
    this.drawerPT = {
      header: {
        class: this.showHeader ? '' : 'hidden',
      },
      root: {
        style: {
          width: 'fit-content',
          maxWidth: '100vw',
        }
      },
      content: {
        class: 'p-0 bg-gray-50',
        style: {
          overflow: 'visible',
          width: 'min(max-content, 100vw)', // ← expands freely, but caps at viewport
          height: 'auto'
        }
      },
    };
  }
}
